import { HideInvalidForNewDirective } from './hide-invalid-for-new.directive';

const ngModule = angular.module('bb.hide-invalid-for-new', []);

ngModule.directive('hideInvalidForNew', HideInvalidForNewDirective);

export default ngModule;
